import { Pipe, PipeTransform } from '@angular/core';
import { SportType } from '../models/sport.model';
import { UnitType } from '../models/unit.model';
import { kilometersPerHourToMilesPerHour } from '../helpers/kilometers-per-hours-to-miles-per-hour.helpers';

@Pipe({
  name: 'pace',
})
export class PacePipe implements PipeTransform {
  private static readonly SECONDS_PER_HOUR: number = 3600;
  private static readonly ROWING_DISTANCE_KM: number = 0.5;

  transform(
    kmH: number,
    sport: SportType,
    unit: UnitType,
    output: 'value' | 'unit' | 'both',
  ): string {
    const unitStr: string = this.getUnit(sport, unit);
    const value: string = this.getValue(kmH, sport, unit);

    switch (output) {
      case 'value':
        return value;
      case 'unit':
        return unitStr;
      case 'both':
        return `${value} ${unitStr}`;
    }
  }

  private getUnit(sport: SportType, unit: UnitType): string {
    if (sport === 'rowing') return '500m';
    return unit === 'imperial' ? 'mile' : 'km';
  }

  private getValue(kmH: number, sport: SportType, unit: UnitType): string {
    if (!kmH || kmH <= 0) return '--';

    const distancePerHour: number =
      sport === 'rowing' ? kmH / PacePipe.ROWING_DISTANCE_KM : this.getDistancePerHour(kmH, unit);

    return this.formatDuration(PacePipe.SECONDS_PER_HOUR / distancePerHour, sport);
  }

  private getDistancePerHour(kmH: number, unit: UnitType): number {
    return unit === 'imperial' ? kilometersPerHourToMilesPerHour(kmH) : kmH;
  }

  private formatDuration(durationInSeconds: number, sport: SportType): string {
    const totalSeconds: number = Math.round(durationInSeconds);
    const minutes: number = Math.floor(totalSeconds / 60);
    const seconds: number = totalSeconds % 60;
    const paddedSeconds: string = String(seconds).padStart(2, '0');

    if (sport === 'rowing') {
      return `${String(minutes).padStart(2, '0')}:${paddedSeconds}`;
    }

    return `${minutes}:${paddedSeconds}`;
  }
}
